import { TrendingUp, Users, Lightbulb, Award } from 'lucide-react';
import { Card } from '../ui/Card';
import { IconBox } from '../ui/IconBox';

  const Benefits = () => {
  const benefits = [
    {
      icon: TrendingUp,
      title: 'Direct Funding Opportunities',
      description: 'Pitch to investors actively deploying capital.'
    },
    {
      icon: Users,
      title: '1:1 Investor Meetings',
      description: 'Private slots with interested investors.'
    },
    {
      icon: Lightbulb,
      title: 'Mentorship & Feedback',
      description: 'Practical feedback from founders and VCs.'
    },
    {
      icon: Award,
      title: 'Media & Visibility',
      description: 'Coverage and brand exposure for finalists.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-primary text-textPrimary">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            Why Startups Love AQT
          </h2>
          <p className="text-xl text-textMuted max-w-3xl mx-auto leading-relaxed">
            Get real investor access — we prioritize quality meetings and actionable follow-ups.
          </p>
        </div>

        {/* Benefit Cards */}
       <div className="grid md:grid-cols-2 gap-8">
  {benefits.map((benefit, index) => (
    <Card
      key={index}
      className="
        p-8 
        rounded-2xl 
        bg-tertiary 
        border border-borderLight 
        shadow-card 
        hover:bg-secondary/70 
        hover:shadow-xl 
        transition-all
        group
      "
      hover
    >
      <IconBox
        icon={benefit.icon}
        size="md"
        className="
          mb-4 
          rounded-xl 
          bg-[linear-gradient(to_right,#22c1c3,#fdbb2d)]
          shadow-[inset_0_0_12px_rgba(255,255,255,0.08)]
 
          text-bluePrimary
          transition-colors
          group-hover:text-white
        "
      />

      <h3
        className="
          text-2xl font-bold 
          text-black 
          mb-3
          transition-colors
          group-hover:text-white
        "
      >
        {benefit.title}
      </h3>

      <p
        className="
          text-textMuted 
          leading-relaxed
          transition-colors
          group-hover:text-white
        "
      >
        {benefit.description}
      </p>
    </Card>
  ))}
</div>


      </div>
    </section>
  );
};

export default Benefits;